export default __webpack_public_path__ + "static/media/avatar.522078c8.png";